import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  makeStyles,
  Avatar,
  TextField,
} from "@material-ui/core";

import SFDialogTitle from "../../../components/SFDialogTitle";
import useTiers from "../../../hooks/useTiers";
import { Loading } from "ra-ui-materialui";
import { useState, useEffect } from "react";
import useSFAlert from "../../../hooks/useSFAlert";

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 12,
  },
  allContainer: {
    width: 695,
    height: 466,
  },
  title: {
    fontSize: 30,
    color: theme.orange,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    paddingLeft: 32,
    paddingRight: 32,
    boxSizing: "border-box",
  },
  topSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    alignItems: "start",
    flexGrow: 1,
  },

  tierListContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  tierMedal: {
    position: "absolute",
    top: 4,
    left: 4,
    width: 38,
    height: 38,
  },
  tierBorder: {
    marginRight: 10,
    width: 46,
    height: 46,
    position: "relative",
    backgroundColor: theme.white,
  },
  tierBorderSelected: {
    backgroundColor: theme.orange,
  },
  buttonContainer: {},
  button: {
    borderRadius: "0 0 0 0",
    margin: "0 !important",
    height: 40,
    width: "100%",
    fontSize: 20,
    marginLeft: 0,
    marginRight: 0,
  },
  dialogAction: {
    padding: 0,
    display: "grid",
    gridTemplateColumns: "100%",
    height: 40,
  },
  rowOneInput: {
    marginTop: 15,
    marginLeft: 20,
    display: "grid",
    gridTemplateColumns: "100px 100px 50px",
    gridGap: 5,
    alignItems: "center",
  },
  rowTwoInput: {
    marginTop: 15,
    marginLeft: 20,
    display: "grid",
    gridTemplateColumns: "100px 100px 20px 100px auto",
    gridGap: 5,
    alignItems: "center",
  },
  textField: {},
}));

const FilterDialog = ({
  open,
  onClose,
  tierFilter,
  nonActiveFilter,
  activeFilter,
  repeatFilter,
  amountFilter,
  lifeTimeValueFilter,
  pointFilter,
  setTierFilter = () => null,
  setNonActiveFilter = () => null,
  setActiveFilter = () => null,
  setRepeatFilter = () => null,
  setAmountFilter = () => null,
  setLifeTimeValueFilter = () => null,
  setPointFilter = () => null,
}) => {
  const classes = useStyles();
  const [alert] = useSFAlert();
  const { tiers, loading } = useTiers();
  const [selectedTier, setSelectedTier] = useState(tierFilter);
  const [nonActiveValue, setNonActiveValue] = useState(nonActiveFilter);
  const [activeValue, setActiveValue] = useState(activeFilter);
  const [repeatValue, setRepeatValue] = useState(repeatFilter);
  // const [amountValue, setAmountValue] = useState(amountFilter);
  const [lifeTimeValueValue, setLifeTimeValueValue] =
    useState(lifeTimeValueFilter);
  // const [pointValue, setPointValue] = useState(pointFilter);
  useEffect(() => {
    setSelectedTier(tierFilter);
  }, [tierFilter]);
  const validateFilter = () => {
    // if (amountValue) {
    //   if (amountValue.from && amountValue.to) {
    //   } else return false;
    // }
    if (lifeTimeValueValue) {
      if (lifeTimeValueValue.from && lifeTimeValueValue.to) {
      } else return false;
    }

    if (repeatValue) {
      if (repeatValue.from && repeatValue.to) {
      } else return false;
    }
    return true;
  };

  if (loading)
    return (
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <Loading />
      </Dialog>
    );
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      PaperProps={{
        className: classes.paper,
      }}
    >
      <SFDialogTitle
        id="customized-dialog-title"
        onClose={onClose}
        title="Filter"
        disableClose={false}
      />

      <DialogContent classes={{ root: classes.dialogContent }}>
        <Box className={classes.topSection}>
          <Typography
            align="left"
            style={{ marginTop: 0, fontSize: 14, alignSelf: "start" }}
          >
            Tier
          </Typography>
          <Box className={classes.tierListContainer}>
            {tiers.map((tier) => {
              return (
                <>
                  <Avatar
                    className={[
                      classes.tierBorder,
                      tier === selectedTier ? classes.tierBorderSelected : null,
                    ]}
                  >
                    <Avatar
                      src={tier.image_url}
                      alt={tier.name}
                      className={[classes.tierMedal]}
                      onClick={() =>
                        tier === selectedTier
                          ? setSelectedTier(-1)
                          : setSelectedTier(tier)
                      }
                    />
                  </Avatar>
                </>
              );
            })}
          </Box>
        </Box>

        <FilterOneInput
          label="Non-active Period"
          prefix="Last "
          defaultValue={nonActiveValue}
          setValue={setNonActiveValue}
        />
        <FilterOneInput
          label="Active Period"
          prefix="Last "
          defaultValue={activeValue}
          setValue={setActiveValue}
        />
        <FilterTwoInput
          label="Repeat"
          defaultValue={repeatValue}
          setValue={setRepeatValue}
          unit="times"
        />

        {/* <FilterOneInput
          label="Amount"
          defaultValue={amountValue}
          setValue={setAmountValue}
        /> */}
        <FilterTwoInput
          label="LTV"
          unit="THB"
          defaultValue={lifeTimeValueValue}
          setValue={setLifeTimeValueValue}
        />
        {/* <FilterOneInput
          label="Point"
          defaultValue={pointValue}
          setValue={setPointValue}
          unit="pts."
        /> */}
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button
          onClick={() => {
            if (!validateFilter()) {
              return alert("Please complete from and to");
            }
            setTierFilter(selectedTier);
            setActiveFilter(activeValue);
            setNonActiveFilter(nonActiveValue);
            setRepeatFilter(repeatValue);
            // setAmountFilter(amountValue);
            // setPointFilter(pointValue);
            setLifeTimeValueFilter(lifeTimeValueValue);
            onClose();
          }}
          color="primary"
          variant="contained"
          className={classes.button}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const FilterOneInput = ({
  label,
  unit = "months",
  defaultValue,
  setValue,
  prefix,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.rowOneInput}>
      <Typography style={{ fontWeight: "bolder" }}>{label}</Typography>
      <Box
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        {prefix && (
          <>
            <Typography>{prefix}</Typography>
            <Box style={{ width: 50 }}></Box>
          </>
        )}
        <TextField
          size="small"
          className={classes.textField}
          defaultValue={defaultValue}
          onChange={(e) => setValue(e.target.value)}
          type="number"
          variant="outlined"
        ></TextField>
      </Box>
      <Typography>{unit}</Typography>
    </Box>
  );
};

const FilterTwoInput = ({ label, unit = "THB", defaultValue, setValue }) => {
  const classes = useStyles();
  return (
    <Box className={classes.rowTwoInput}>
      <Typography style={{ fontWeight: "bolder" }}>{label}</Typography>
      <TextField
        size="small"
        className={classes.textField}
        defaultValue={defaultValue?.from}
        onChange={(e) => setValue({ ...defaultValue, from: e.target.value })}
        type="number"
        variant="outlined"
      />
      <Typography> - </Typography>
      <TextField
        size="small"
        className={classes.textField}
        defaultValue={defaultValue?.to}
        onChange={(e) => {
          setValue({ ...defaultValue, to: e.target.value });
        }}
        type="number"
        variant="outlined"
      />
      <Typography>{unit}</Typography>
    </Box>
  );
};

export default FilterDialog;
